'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _nodeUuid = require('node-uuid');

var _reactBootstrap = require('react-bootstrap');

var _util = require('lodash/util');

var _translate = require('../../language/translate');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Renders the form progress bar.
 * @extends {Component}
 */
var ProgressBarComponent = function (_React$Component) {
  _inherits(ProgressBarComponent, _React$Component);

  function ProgressBarComponent() {
    _classCallCheck(this, ProgressBarComponent);

    return _possibleConstructorReturn(this, (ProgressBarComponent.__proto__ || Object.getPrototypeOf(ProgressBarComponent)).apply(this, arguments));
  }

  _createClass(ProgressBarComponent, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var numPages = this.props.navigation.numPages;

      this.pages = (0, _util.range)(numPages).map(function (element) {
        return _extends({}, element, {
          key: (0, _nodeUuid.v4)()
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props$navigation = this.props.navigation,
          currentPage = _props$navigation.currentPage,
          numPages = _props$navigation.numPages;


      return _react2.default.createElement(
        _reactBootstrap.Row,
        { className: 'ingle-form-progress-bar bs-wizard' },
        this.pages.map(function (element, index) {
          return _react2.default.createElement(
            _reactBootstrap.Col,
            {
              key: element.key,
              xs: 12 / numPages,
              className: (0, _classnames2.default)({
                'bs-wizard-step': true,
                disabled: currentPage < index + 1,
                active: currentPage === index + 1,
                complete: currentPage > index + 1
              })
            },
            _react2.default.createElement(
              'div',
              { className: 'text-center bs-wizard-stepnum' },
              _this2.props.progressText[index] && _this2.props.progressText[index].title || (0, _translate.t)('Step') + ' ' + (index + 1)
            ),
            _react2.default.createElement(
              'div',
              { className: 'progress' },
              _react2.default.createElement('div', { className: 'progress-bar' })
            ),
            _react2.default.createElement('a', { className: 'bs-wizard-dot' }),
            _react2.default.createElement(
              'div',
              { className: 'bs-wizard-info text-center' },
              _this2.props.progressText[index] && _this2.props.progressText[index].description
            )
          );
        })
      );
    }
  }]);

  return ProgressBarComponent;
}(_react2.default.Component);

ProgressBarComponent.propTypes = {
  navigation: function navigation(props, propName, componentName) {
    // must work with Bootstrap grid
    if (!props[propName].numPages || 12 % props[propName].numPages !== 0) {
      return new Error(propName + ' supplied to component ' + componentName + ' must divide evenly into 12.');
    }
    return undefined;
  },
  progressText: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.shape({
    title: _react2.default.PropTypes.string,
    description: _react2.default.PropTypes.string
  })).isRequired
};
exports.default = ProgressBarComponent;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/common/ProgressBarComponent.jsx
// module id = 1660
// module chunks = 0